<template>
    <div v-if="$GlobalStore.isShowAfterPositionPopup()" style="position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: #210f0370; z-index: 100;">
        <div v-if="$GlobalStore.isApply()" style="position: absolute; width: calc(100% - 60px); background-color: #fff; top: 50%; left: 50%; transform: translate(-50%, -50%); border-radius: 27px; padding: 20px; padding-bottom: 45px;">
            <div @click.stop="$GlobalStore.setIsShowAfterPositionPopup(false)" style="color: #808080; font-weight: 700; margin-bottom: 6px;">닫기</div>
            <div style="background: linear-gradient(89.76deg, #FF711180 0.21%, #C7C7C780 99.79%); box-shadow: 0px 4.57px 4.57px 0px #00000040; padding: 24px; border-radius: 22px; text-align: center;">
                <ProfileImage style="width: 120px;" :imagePath="myImagePath"></ProfileImage>
                <div style="margin-top: 16px;">
                    <div style="font-weight: 700;">{{ myName }}<span style="font-size: 14px; font-weight: 900; margin-left: 4px; color: var(--color-main);">{{ myPosition }}</span></div>
                </div>
            </div>
            <div style="margin-top: 17px; text-align: center;">
                <div style="font-weight: 700">포지션이 적용 되었어요</div>
                <div v-if="!isHopeToBeSoccerPlayer" style="color: #606060; font-size: 14px; line-height: 20px; margin-top: 16px;">내 포지션을 찾았으니,<br> 이제 본격적으로 축구를 배워볼까요?</div>
                <div v-else style="color: #606060; font-size: 14px; line-height: 20px; margin-top: 16px;">포지션을 찾았으니,<br>감독님께 보여드릴 입단 요청서를 작성해보세요</div>
            </div>
            <div v-if="!isHopeToBeSoccerPlayer" @click.stop="showWriteForm" style=" margin: 0 auto; margin-top: 34px; font-weight: 700; font-size: 14px; width: 224px; height: 64px; line-height: 64px; text-align: center; border-radius: 57px; background-color: #210f03; color: var(--color-main);">축구 궁금증 해결하기</div>
            <div v-else @click.stop="showWriteForm" style=" margin: 0 auto; margin-top: 34px; font-weight: 700; font-size: 14px; width: 224px; height: 64px; line-height: 64px; text-align: center; border-radius: 57px; background-color: #210f03; color: var(--color-main);">입단 요청서 작성하기</div>
        </div>
        <div v-else style="position: absolute; width: calc(100% - 60px); background-color: #fff; top: 50%; left: 50%; transform: translate(-50%, -50%); border-radius: 27px; padding: 20px; padding-bottom: 45px;">
            <div @click.stop="$GlobalStore.setIsShowAfterPositionPopup(false)" style="color: #808080; font-weight: 700; margin-bottom: 6px;">닫기</div>
            <div>
                <img v-if="isHopeToBeSoccerPlayer" style="width: 100%;" :src="require('@/assets/img/deok_bae_say.png')" alt="">
                <img v-else style="width: 100%;" :src="require('@/assets/img/jud_say.png')" alt="">
            </div>
            <div style="text-align: center;">
                <div v-if="!isHopeToBeSoccerPlayer" style="font-size: 22px; font-weight: 700; line-height: 36px;">포지션 찾아봤으니<br>이제 축구를 배워볼까요</div>
                <div v-else style="font-size: 22px; font-weight: 700; line-height: 36px;">포지션 찾아봤으니<br>입단 요청서를 보내보세요</div>
                <div v-if="!isHopeToBeSoccerPlayer" style="color: #606060; font-size: 14px; line-height: 20px; margin-top: 16px;">궁금한 내용이 있다면 자유롭게 작성하면<br>축구 전문가들이 여러분의 궁금증을 해결해드려요</div>
                <div v-else style="color: #606060; font-size: 14px; line-height: 20px; margin-top: 16px;">감독님들로부터 스카웃이 오거나<br>내가 직접 원하는 팀으로 테스트 요청을 할 수 있어요</div>
            </div>
            <div v-if="!isHopeToBeSoccerPlayer" @click.stop="showWriteForm" style=" margin: 0 auto; margin-top: 34px; font-weight: 700; font-size: 14px; width: 224px; height: 64px; line-height: 64px; text-align: center; border-radius: 57px; background-color: #210f03; color: var(--color-main);">축구 궁금증 해결하기</div>
            <div v-else @click.stop="showWriteForm" style=" margin: 0 auto; margin-top: 34px; font-weight: 700; font-size: 14px; width: 224px; height: 64px; line-height: 64px; text-align: center; border-radius: 57px; background-color: #210f03; color: var(--color-main);">입단 요청서 작성하기</div>
        </div>
    </div>
</template>

<script>
import ProfileImage from '@/components/common/ProfileImage'

export default {
    name: 'AfterFindPositionPopoup',
    components: {ProfileImage},
    props: {
        btnClickEvent: {
            type: Function,
            default: () => {}
        },
    },
    computed: {
        myImagePath() {
            return this.$GlobalStore.loginInfo().image_path
        },
        myName() {
            return this.$GlobalStore.loginInfo().nic_name
        },
        myPosition() {
            return this.$GlobalStore.loginInfo().position
        },
        isHopeToBeSoccerPlayer() {
            const visit_reason = this.$GlobalStore.loginInfo().visit_reason
            const hopeToBeSoccerPlayerChips = ['축구선수 희망', '축구 진로 상담', '축구팀 입단']
            return hopeToBeSoccerPlayerChips.includes(visit_reason);
        },
    },
    data() {
        return {
        }
    },
    methods: {
        showWriteForm() {
            this.$GlobalStore.setIsShowAfterPositionPopup(false, false)
            this.btnClickEvent(this.isHopeToBeSoccerPlayer)
        },
    }
}
</script>

<style scoped>

</style>